function getConcealedData(analyticsType, isAjax, ipData) {
    if (!isAjax) {
        new WOW().init();
    }
    var analType = analyticsType;

    var countryNameNode = document.querySelector(".js-country_name");
    var cityNameNode = document.querySelector(".js-city_name");
    var timezoneNode = document.querySelector(".js-timezone");
    var regionNode = document.querySelector(".js-region_name");

    var countryElements = document.querySelectorAll('.js-show-country');
    var cityElements = document.querySelectorAll('.js-show-city');
    var timezoneElements = document.querySelectorAll('.js-show-timezone');
    var regionElements = document.querySelectorAll('.js-show-region');

    var countryData = isAjax ? ipData.country : countryNameNode.dataset["countryname"];
    var cityData = isAjax ? ipData.city : cityNameNode.dataset["cityname"];
    var timezoneData = "";
    var regionData = "";

    hideName(countryNameNode, countryData);
    hideName(cityNameNode, cityData);
    if (timezoneNode) {
        timezoneData = isAjax ? ipData.timezone : timezoneNode.dataset["timezone"];
        hideName(timezoneNode, timezoneData);
    }
    if (regionNode) {
        regionData = isAjax ? ipData.region : regionNode.dataset["regionname"];
        hideName(regionNode, regionData);
    }

    function hideName(node, value) {
        var encodedName = "", i = 0;
        if (node && value) {
            while (i < value.length) {
                encodedName += "&bull;";
                i++;
            }
        }
        node.innerHTML = encodedName;
    }

    function sendGAEvent(eventName) {
        var referrer = document.referrer;
        if (referrer === '') {
            referrer = 'No Referrer';
        }
        if (analType == 'ga') {
            ga('send', 'event', eventName, document.location.href, referrer, 0, {'nonInteraction': true});
        } else if (analType == 'gtag') {
            gtag('event', document.location.href, {
                'referrer': referrer,
                'event_category': eventName
            });
        }
    }

    revealData(countryElements, countryNameNode, 'country', countryData);
    revealData(cityElements, cityNameNode, 'city', cityData);
    if (timezoneElements) {
        revealData(timezoneElements, timezoneNode, 'timezone', timezoneData);
    }
    if (regionElements) {
        revealData(regionElements, regionNode, 'region', regionData);
    }

    function revealData(elements, node, category, value) {
        for (var i = 0, len = elements.length; i < len; i++) {
            elements[i].onclick = function () {
                if (this.className.match("hidden_info--visible") === null) {
                    for (var j = 0; j < elements.length; j++) {
                        elements[j].className += " hidden_info--visible";
                    }
                    node.innerHTML = value;
                    node.classList.remove("info__value--clipped");
                    node.style = ''; // made for unseen page. to hidden text was set custom styles and by this we remove that styles
                    document.getElementById("ip_details-" + category).removeChild(document.querySelector(".text_button.js-show-" + category));
                    sendGAEvent("click_" + category);
                }
            };
        }
    }
}
